import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section className="bg-pale px-4 py-6 md:px-12 md:py-8" data-id="element-202" data-mp="20qnmhm6g4bn0">
      <h2 className="mx-auto max-w-[600px] text-center font-heading text-[22px] font-extrabold uppercase leading-[1.25] tracking-[-0.3px] text-navy md:text-[30px]" data-id="element-203" data-mp="1n0twv1n49nc8">
        What orthopedic specialists are saying
      </h2>
      <div className="mt-3 space-y-2.5" data-id="element-204" data-mp="1d12zms768u8g">
        {testimonials.map(t => <figure key={t.name} className="rounded-md border border-line bg-white px-3.5 py-3 md:px-4" data-id="element-205" data-mp="1i17iupzgs32d">
            <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-206" data-mp="1427vdlnotu7s">
              {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden data-id="element-207" data-mp="1831hqalhf0yk" data-mpi={i} />)}
            </div>
            <blockquote className="mt-1.5 text-[14px] leading-[1.45] text-ink md:text-[15px]" data-id="element-208" data-mp="32gspf4k93ard">“{t.quote}”</blockquote>
            <figcaption className="mt-2" data-id="element-209" data-mp="2v12leyqzkfa4">
              <span className="block font-heading text-[12px] font-extrabold uppercase text-navy" data-id="element-210" data-mp="2uzzx8yl1sqxw">
                {t.name}, {t.age}
              </span>
              <span className="block text-[12px] leading-snug text-ink" data-id="element-211" data-mp="34rxaeavm9sz9">{t.role}</span>
            </figcaption>
          </figure>)}
      </div>
    </section>;
}